exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title-head[data-v-c77c10f6]{margin-top: 0;\n}\n.terms-para[data-v-c77c10f6]{padding-bottom:2rem;\n}\n.terms-para[data-v-c77c10f6]:last-child{padding-bottom:0;\n}\n.terms-para *[data-v-c77c10f6] {line-height:170%;\n}\n.terms-para ul[data-v-c77c10f6]{padding-left:1rem;\n}\n.terms-para ul li[data-v-c77c10f6]{list-style:decimal;padding:0 0 1rem .5rem;\n}\n.terms-para ul li[data-v-c77c10f6]:last-child{padding-bottom:0;\n}\n.terms-para>p[data-v-c77c10f6]{padding-bottom:1rem;\n}\n.terms-para>p[data-v-c77c10f6]:last-child{padding-bottom:0;\n}\nh4.terms-title[data-v-c77c10f6]{font-size:1rem;padding-bottom:1rem;color:#608197;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c77c10f6","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Terms.vue
// module id = DK8c
// module chunks = 2 3 4 5 6